import moment from "moment";

import { axiosWithAuth } from "helpers";

export const reportingService = {
	getAgentOfficeReport,
	getAgentOfficeReportsList,
	getAgentReportsList,
	getDetailedAgentReport,
	getInternalReport,
	getInternalReportsList,
	getSummaryAgentReport,
	unlockAndSend,
	unlockReports,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;
const PAGE_SIZE = 50;

const formatPaidYear = paidMonth =>
	paidMonth && moment(paidMonth, "MMMM YYYY").format("YYYY");
const formatPaidMonth = paidMonth =>
	paidMonth && moment(paidMonth, "MMMM YYYY").format("M");

function getAgentReportsList({ paidMonth, paidYear, page, sortBy, filters }) {
	const businessUnit =
		filters?.businessUnit?.parent?.name || filters?.businessUnit?.name;

	const businessUnitHierarchy =
		filters?.businessUnit?.parent && filters?.businessUnit?.name;

	let sortType = null;
	if (sortBy.id) {
		switch (sortBy.id) {
			case "agent_name":
				sortType = "agent_name";
				break;
			case "agent_office":
				sortType = "agent_office_name";
				break;
			case "paid_month":
				sortType = "paid_date";
				break;
			default:
				sortType = "none";
		}
	}

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			agent_name: filters?.agentName,
			agent_office_id: filters?.agentOfficeDdl?.id,
			partner_type: filters?.partnerType?.name,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			paid_year: paidYear,
			paid_month: paidMonth,
			sort_type: sortType,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/reports/agents`,
	};

	return axiosWithAuth(options);
}

function getAgentOfficeReportsList({
	paidMonth,
	paidYear,
	page,
	sortBy,
	filters,
}) {
	const businessUnit =
		filters?.business_unit?.parent?.name || filters?.business_unit?.name;

	const businessUnitHierarchy =
		filters?.business_unit?.parent && filters?.business_unit?.name;

	let sortType = null;
	if (sortBy.id) {
		switch (sortBy.id) {
			case "agent_office":
				sortType = "agent_office_name";
				break;
			case "paid_month":
				sortType = "paid_date";
				break;
			default:
				sortType = "none";
		}
	}

	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			agent_office_id: filters?.agentOfficeDdl?.id,
			partner_type: filters?.partnerType?.name,
			business_unit: businessUnit,
			business_unit_hierarchy: businessUnitHierarchy,
			paid_year: paidYear,
			paid_month: paidMonth,
			sort_type: sortType,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
		},
		url: `${RESIDUALS_API_URL}/api/reports/agent_offices`,
	};

	return axiosWithAuth(options);
}

function getInternalReportsList({ page, sort, filters }) {
	const paidMonth = formatPaidMonth(filters?.paidMonth);
	const paidYear = formatPaidYear(filters?.paidMonth);
	const report_type = filters?.report_type?.value;
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			paid_year: paidYear,
			paid_month: paidMonth,
			ascending: sort.desc,
			sort_type: sort.id,
			report_type,
		},
		url: `${RESIDUALS_API_URL}/api/reports/internal_sales`,
	};

	return axiosWithAuth(options);
}

function getDetailedAgentReport({ agentId, paidDate }) {
	getAgentReport({ agentId, paidDate, type: "detailed_report" });
}

function getSummaryAgentReport({ agentId, paidDate }) {
	getAgentReport({ agentId, paidDate, type: "summary_report" });
}

function getAgentReport({ agentId, paidDate, type }) {
	try {
		const paidMonth = formatPaidMonth(paidDate);
		const paidYear = formatPaidYear(paidDate);

		const user = JSON.parse(localStorage.getItem("user") || "");
		const url = `${RESIDUALS_API_URL}/api/reports/${paidYear}/${paidMonth}/agents/${agentId}/${type}?token=${user.access_token}`;
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function getAgentOfficeReport({ agentOfficeId, paidDate }) {
	try {
		const paidMonth = formatPaidMonth(paidDate);
		const paidYear = formatPaidYear(paidDate);

		const user = JSON.parse(localStorage.getItem("user") || "");
		const url = `${RESIDUALS_API_URL}/api/reports/${paidYear}/${paidMonth}/agent_offices/${agentOfficeId}/report?token=${user.access_token}`;
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function getInternalReport({ paidDate, type = "" }) {
	try {
		const paidMonth = moment(paidDate).format("M");
		const paidYear = moment(paidDate).format("YYYY");
		const user = JSON.parse(localStorage.getItem("user") || "");
		let url = `${RESIDUALS_API_URL}/api/reports/${paidYear}/${paidMonth}/internal_sales/report?token=${user.access_token}`;
		if (type === "aurora_house_account") {
			url = `${RESIDUALS_API_URL}/api/reports/${paidYear}/${paidMonth}/house_account/report?token=${user.access_token}`;
		}
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function unlockAndSend({ paidYear, paidMonth }) {
	const options = {
		method: "POST",
		url: `${RESIDUALS_API_URL}/api/reports/${paidYear}/${paidMonth}/unlock_and_send`,
	};

	return axiosWithAuth(options);
}

function unlockReports({ paidYear, paidMonth }) {
	const options = {
		method: "POST",
		url: `${RESIDUALS_API_URL}/api/reports/${paidYear}/${paidMonth}/unlock`,
	};

	return axiosWithAuth(options);
}
